import "backboneAjaxQAdapter";

import GenericView from 'views/generic.view.ts';

import Handlebars from 'handlebars';
import Template from 'text-loader!../../../../templates/analytics/venues/users/analytics_users_statistics.template.html';

import Collection from '../../../../collections/analytics/users_statistics.paginated.collection.ts';

import colors from '../../../../../libs/assets/colors.js';
import i18n  from "l10n";

import UserStatisticRowView from './user_statistics.row.view.ts';

export default GenericView.extend({
    el: "#statistics-container",
    tagName: 'div',
    className: 'venue-statistic',
	template: Handlebars.compile(Template),
	venueId: null,
	from: null,
	to: null,
    initialize: function (options) {
        var self = this;

        this.venueId = options ? options.venueId : null;
        this.from = options ? options.from : null;
        this.to = options ? options.to : null;

	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		var self = this;
		this.superRender();

        var templateParams = $.extend({}, this.collection.models, {"lang": i18n.lng()});
        var templateData = this.template( templateParams );

		this.$el.html( templateData );

        return this;
	},
	events:{

    },
    getCollectionUrl: function() {
        return "rest/api/statistics/venues/"+this.venueId+"/agents";
    },
    loadData: function() {
        if(!this.venueId || this.venueId < 1 || !this.from || !this.to) {
            // todo: show error message
            return;
        }

        var self = this;
        this.collection = new Collection();

        this.collection.url = this.getCollectionUrl() + "?filter=" + encodeURIComponent("date>=" + this.from + ", date<=" + this.to);

        this.collection.on( 'sync',
            function() {
                self.successAgentStatisticsData();
            }
        , this );
        this.collection.on( 'error', this.errorAgentStatisticsData, this );
        this.collection.getFirstPage();
    },
    successAgentStatisticsData: function() {
        var $statsContainer = this.$el;
        $statsContainer.empty();

        this.render();

        if (this.collection.models.length > 0) {
            $statsContainer.find("#agent-statistics-container").show();
            $statsContainer.find("#errorqueues").hide();

            // show "Export Data" button
            $statsContainer.find(".export-data").show();
            $statsContainer.find(".export-data").find("#export-link").attr("href", this.getCollectionUrl() + "/export?lang="+ i18n.lng() +"&filter=" + encodeURIComponent("date>=" + this.from + ", date<=" + this.to));

            this.renderUserStatistics();
        }
        else {
            $statsContainer.find("#agent-statistics-container").hide();
            $statsContainer.find("#errorqueues").show();

            // hide "Export Data" button
            $statsContainer.find(".export-data").hide();
            $statsContainer.find(".export-data").find("#export-link").removeAttr("href");
        }
    },
    errorQueueStatisticsData: function(collection, xhr, options) {
        this.onErrorHandler(collection, xhr, options);

    },
    renderUserStatistics: function() {
        var $container = this.$el.find("#agent-statistics-container").find(".statsContainer");
        for(var i = 0; i< this.collection.models.length; i++) {
            var tempModel = this.collection.models[i];

            var userStatisticRowView = new UserStatisticRowView({"data": tempModel.attributes});
            $container.append( userStatisticRowView.render().el );
        }
    }

});


